import React from 'react';
import { Typography } from '@navi/web-ui/lib/primitives';
import Button from '@primitives/Button';
import CopyToClipboardIcon from '@cp/src/assets/icons/CopyToClipboardIcon';

interface LonghornInfoPopoverProps {
  name: string;
  email: string;
  updatedOn: string;
  source: string;
  onViewProof: () => void;
}

const LonghornInfoPopover: React.FC<LonghornInfoPopoverProps> = ({
  name,
  email,
  updatedOn,
  source,
  onViewProof
}) => {
  const handleCopyEmail = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(email);
  };

  const showProof = (e: React.MouseEvent) => {
    e.stopPropagation();
    onViewProof();
  };

  return (
    <div className="flex flex-col px-3 py-2 w-[280px] gap-2">
      <div className="flex flex-row justify-between">
        <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
          Name
        </Typography>
        <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
          {name || 'NA'}
        </Typography>
      </div>

      <div className="flex flex-row justify-between">
        <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
          Email
        </Typography>
        <div className="flex flex-row gap-[2px] items-center">
          <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
            {email || 'NA'}
          </Typography>
          {email && (
            <Button variant="text" onClick={handleCopyEmail} className="!p-0">
              <CopyToClipboardIcon width={16} height={16} />
            </Button>
          )}
        </div>
      </div>

      <div className="flex flex-row justify-between">
        <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
          Updated on
        </Typography>
        <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
          {updatedOn || 'NA'}
        </Typography>
      </div>

      <div className="flex flex-row justify-between">
        <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
          Source
        </Typography>
        <Typography variant="p3" className="text-sm font-medium" color="var(--grayscale-2)">
          {source || 'NA'}
        </Typography>
      </div>

      <div className="flex flex-row justify-between">
        <Typography variant="p3" className="text-sm" color="var(--grayscale-2)">
          Proof
        </Typography>
        <Button variant="text" onClick={showProof} className="!p-0 !h-auto">
          View
        </Button>
      </div>
    </div>
  );
};

export default LonghornInfoPopover;
